module.exports = __webpack_public_path__ + "img/P2_side_right2.9a21d564.png";